import IconCheck from 'assets/icons/check-small.svg';
import IconClose from 'assets/icons/close-new.svg';
import cn from 'classnames';

interface PropTypes {
  dataTest?: string;
  isChecked: boolean;
  showIcon?: boolean;
  onChange: (value: any) => void;
}

const Toggle: React.FC<PropTypes> = ({
  dataTest,
  isChecked,
  showIcon = true,
  onChange,
}) => (
  <label className="flex" data-test={dataTest}>
    <input
      data-test={`${dataTest}-input`}
      type="checkbox"
      className="peer sr-only"
      checked={isChecked}
      onChange={onChange}
    />
    <div
      className={cn(
        'inline-flex h-[31px] w-[51px] cursor-pointer items-center rounded-full p-0.5 transition-colors duration-300 ease-in-out',
        isChecked ? 'bg-green-400' : 'bg-grey-200'
      )}
    >
      <div
        className={cn(
          'bg-other-white relative flex h-full w-[27px] items-center justify-center rounded-full shadow-md transition-transform duration-300 ease-in-out',
          isChecked ? 'translate-x-[20px]' : 'translate-x-0'
        )}
      >
        {showIcon && (
          <>
            <IconClose
              className={cn(
                'text-grey-200 absolute p-0.5 transition-opacity duration-300 ease-in-out',
                isChecked ? 'opacity-0' : 'opacity-100'
              )}
            />
            <IconCheck
              className={cn(
                'absolute p-0.5 text-green-400 transition-opacity duration-300 ease-in-out',
                !isChecked ? 'opacity-0' : 'opacity-100'
              )}
            />
          </>
        )}
      </div>
    </div>
  </label>
);

export default Toggle;
